import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        PenPower Technology LTD.Copyright © 2020 PenPower All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer;